/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_LoggedInputs */

const en_ui_logged = /** @type {(inputs: Ui_LoggedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`logged`)
};

/** @type {(inputs: Ui_LoggedInputs) => LocalizedString} */
const ar_ui_logged = en_ui_logged;

/** @type {(inputs: Ui_LoggedInputs) => LocalizedString} */
const he_ui_logged = en_ui_logged;

/** @type {(inputs: Ui_LoggedInputs) => LocalizedString} */
const ur_ui_logged = en_ui_logged;

/** @type {(inputs: Ui_LoggedInputs) => LocalizedString} */
const es_ui_logged = en_ui_logged;

/** @type {(inputs: Ui_LoggedInputs) => LocalizedString} */
const fr_ui_logged = en_ui_logged;

/** @type {(inputs: Ui_LoggedInputs) => LocalizedString} */
const de_ui_logged = en_ui_logged;

/** @type {(inputs: Ui_LoggedInputs) => LocalizedString} */
const pt_ui_logged = en_ui_logged;

/** @type {(inputs: Ui_LoggedInputs) => LocalizedString} */
const hi_ui_logged = en_ui_logged;

/** @type {(inputs: Ui_LoggedInputs) => LocalizedString} */
const bn_ui_logged = en_ui_logged;

/**
* | output |
* | --- |
* | "logged" |
*
* @param {Ui_LoggedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_logged = /** @type {((inputs?: Ui_LoggedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_LoggedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_logged(inputs)
	if (locale === "he") return he_ui_logged(inputs)
	if (locale === "ur") return ur_ui_logged(inputs)
	if (locale === "es") return es_ui_logged(inputs)
	if (locale === "fr") return fr_ui_logged(inputs)
	if (locale === "de") return de_ui_logged(inputs)
	if (locale === "pt") return pt_ui_logged(inputs)
	if (locale === "hi") return hi_ui_logged(inputs)
	if (locale === "bn") return bn_ui_logged(inputs)
	return /** @type {LocalizedString} */ ("logged")
});